import { ShippingRates } from "../modules/shippingRates";

export const ShippingRatesPage = () => {
  return <ShippingRates />;
};
